module.exports = new __parcel__URL__("trojan-avocado.87b52894.png").toString();